import React, { useState, useContext, useEffect, useRef } from 'react';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Subtitle2, Title3, Body1, Caption1, Subtitle1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Input, Image, Card, InfoLabel, ButtonProps, Tooltip, Link, Textarea, ToggleButton } from "@fluentui/react-components";
import { Info20Regular, Open20Regular, GroupList20Regular, TrayItemRemove20Filled, DesktopPulse20Regular, Wrench20Regular, ShieldQuestion20Regular, LockClosedKey20Regular, BookDatabase20Regular, BookTemplate20Regular, ChatMultipleHeart20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize20Regular, Dismiss16Regular, DismissSquare24Filled, FilterAdd20Filled, Info20Filled, Delete20Regular, AddSquare20Regular } from "@fluentui/react-icons";
import { fullscreenIcon, lightTheme, messageTheme, primaryIcon, exitIcon, secondaryIcon, overflowDivider, buttonContent, inputFieldCSS, dividerWidthStyle, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { DefaultButton, Label, PrimaryButton, Stack, StackItem, TooltipHost } from "@fluentui/react";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Breadcrumbs } from '../../../components/breadcrumbs/breadcrumbs.component';
import { SideMenu } from '../../../components/side_menu/inline_side_menu.component';
import { OverflowSetCustomExample } from '../../../components/side_menu/overFlowSet.component';
import { SearchBar } from '../../../components/searchbar/searchbar.component';
import { MenuDropdown } from '../../../components/dropdown/menu.component';
import { DropdownComponent } from '../../../components/dropdown/dropdown.component';
import { Pagination } from '../../../components/pagination/pagination.component';
import { ToastComponent } from '../../../components/toast/toast.component';
import { SkeletonDataTable } from '../../../components/skeleton/skeletonDataTable';
import OverLay from '../../../components/side_menu/overlay_side_menu.component';
import FullScreenButton from '../../../components/fullscreen/fullScreen.component';
import { usePermissionStore } from "../../../Store/permissionStore";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from '../../../hooks/globalContext';
import { DatepickerComponent } from '../../../components/picker/datepicker.component';
import { DataTable } from "../../../components/data_table/data_table.component";
import { InfoBar } from '../../../components/infoBar/infoBar.component';
import { RadioGroups } from '../../../components/radio_group/radioGroup.component';
import { CSVLink } from 'react-csv';
import { CensusData, CheckboxState } from "../../../interfaces/devices/census_interface";
import { DateComponent } from '../dateComponent';
import Event_func from './event_func';
import { Form } from '@rjsf/fluent-ui';
import validator from '@rjsf/validator-ajv8';
import { CustomWidgets } from '../../../components/form-components';

const SubEvent = () => {
    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [isOverlayFilter, setIsOverlayFilter] = useState(false);
    const [isfilter, setIsFilter] = useState(false);
    const [isResetDisabled, setResetDisabled] = useState(true);
    const [refreshToast, setRefreshToast]: any = useState(false);
    const [errorToast, setErrorToast] = useState(false);
    const [isToast, setIsToast] = useState(false);
    const [final_data, set_final_data]: any = useState<CensusData[] | null>(null);
    const [devicesTableData, setDevicesTableData] = useState([]);
    const [filterArray, setFilterArray] = useState<string[]>([]);
    const [searchVal, setSearchVal] = useState("");
    const [overLayData, setOverLayData] = useState<any>({});
    const [totalPages, setTotalPages] = useState<number>(1);
    const [currentPageNo, setCurrentPageNo] = useState<number>(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [selectedTableData, setSelectedTableData] = useState([]);
    const [filterMenuOpenOverlay, setFilterMenuOpenOverlay] = useState(false);
    const [exportBtnClicked, setExportBtnClicked] = useState(false);
    const [isRefresh, setIsRefresh]: any = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [filterColumnsData, setFilterColumnsData] = useState([]);
    const [troubleshooterList, setTroubleshooterList] = useState([])
    const [selectedTroubleshooterList, setSelectedTroubleshooterList] = useState([]);
    const [toastAlertError, setToastAlertError] = useState(false);
    const [toastAlertEdit, setToastAlertEdit] = useState(false)
    const [toastAlertCreate, setToastAlertCreate] = useState(false)
    const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
    const [importedDataInserted, setImportedDataInserted] = useState<any>(false);
    const [jsonData, setJsonData] = useState({});
    const [uiData, setUiData] = useState({});
    const [formDataAlert, setFormDataAlert]: any = useState({});
    const [editBtnClicked, setEditBtnClicked]: any = useState(false);
    const [dropDownValue1, setDropDownValue1] = useState<any>();
    const [dropDownValue2, setDropDownValue2] = useState<any>();
    const [exportData, setExportData] = useState([]);
    const [exportDetails, setExportDetails]: any = useState([]);
    const [deleteAlert, setIsDeleteAlert] = useState(false)
    const [toastAlertDelete, setToastAlertDelete] = useState(false)
    const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
    const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
    const [loading, setLoading] = useState(true);
    const [isOsName, setOsName] = useState([]);
    const [rowID, setRowID]: any = useState(null);
    const contextValue: any = useContext(GlobalContext);
    const [overlayName, setOverlayName] = useState('');
    const [isLatest, setIsLatest] = useState<boolean>(true);
    const [fromDate, setFromDate] = useState<Date | null>(null);;
    const [toDate, setToDate] = useState<Date | null>(null);;
    const [selectedAsset, setSelectedAsset]: any = useState();
    const [singleAsset, setSingleAsset] = useState([]);
    const [singleTableData, setSingleTableData]: any = useState([]);

    // EXPORT FUNCTIONALITY
    const handle = useFullScreenHandle();
    const { permissions } = usePermissionStore();
    const navigate = useNavigate();
    var tenantName = contextValue.tenantName;
    var menuItems: any = [];
    const [formData, setFormData]: any = useState({
        name: '',
        description: '',
        pageLimit: '',
        fromDate: '',
        toDate: ''
    });
    const formsRefs = useRef(null);

    useEffect(() => {
        if (overlayOpen) {
            const element = document.getElementById("fluent-default-layer-host");
            if (element) {
                element.style.zIndex = '9999999';
            }
        }
    }, [overlayOpen]);

    // REACT JSON FORM RENDERING
    const handleNewFormChange = (e: any) => {
        setFormData({
            ...formData,
            jsonData: e.formData
        });
    }

    const dataschema = singleTableData?.dataSchema?.columnNames
    const tablecolums = dataschema?.map((data: any) => ({ key: data, "label": <Body1Strong>{data} </Body1Strong> }))


    const handleOnCLickEdit = (val: any) => {
        setLoading(true);
        setRowID(val.id);
        setSelectedAsset(val.query)
        contextValue.setSelectedAssetRow(val.query)
        navigate('results');
    }


    const overlayOpenModule = () => {
        setOverlayOpen(true);
        setOverlayName('addeventquery');
        setFromDate(null);
        setToDate(null);
        setIsLatest(true);
        setFormData({
            name: '',
            description: '',
            jsonData: { conditional: [{}] },
            pageLimit: '',
            fromDate: '',
            toDate: ''
        });

    }

    var tempSingleTableData: any = [];
    var menuLists: any = [];

    useEffect(() => {
        // Data table values append code starts here
        singleTableData?.rows !== undefined && singleTableData.rows !== null
            ? singleTableData?.rows.length > 0 && singleTableData?.rows.map((val: any, index: any) => {
                const rowData = {};
                singleTableData?.dataSchema?.columnNames?.forEach((key: any, index: any) => {
                    rowData[key] = { label: <Caption1 >{val[index] === "null" ? "--" : val[index]}</Caption1> };
                });

                {
                    permissions.includes("all") || permissions.includes("alert_Fullaccess") ?
                        tempSingleTableData.push({
                            ...rowData,
                            checkbox: 'hide',
                        })
                        : tempSingleTableData.push({
                            machine: val.id,
                            siteName: val.status === 'Attached' ? 'hide' : 'show',
                            v_memorysize: { label: <Button style={buttonContent} onClick={(e: any) => { handleOnCLickEdit(val) }} appearance="transparent" size="small"> {val.name} </Button> },
                            T: { label: <Caption1 >{val.createdBy}</Caption1> }
                        })
                }
            }) : (tempSingleTableData = []);

        tempSingleTableData.length > 0 ? setSingleAsset(tempSingleTableData) : setSingleAsset([]);
        setTimeout(() => {
            singleTableData?.rows !== undefined && singleTableData?.rows !== null && setLoading(false);
        }, 500);
    }, [singleTableData, permissions, formData]);

    const inputChange = (e: any) => {
        const enteredValue = e.target.value;
        console.log("entered value", enteredValue)
        let name = e.target.name;
        const regexS = /^[A-Za-z ]*$/;
        const regexSN = /^[A-Za-z0-9_ ]*$/;
        const regexN = /^[0-9]*$/;
        if (name === 'filter' && dropDownValue1 === ("Device Name")) {
            if (regexSN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        if (name === 'filter' && dropDownValue1 === ("Nanoheal Version")) {
            if (regexN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        if (name === 'filter' && dropDownValue1 === ("Manufacturer")) {
            if (regexS.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
    }

    useEffect(() => {
        setFormData({ ...formData, fromDate: fromDate, toDate: toDate })
    }, [toDate, fromDate])


    const handleFilterArray = (): any => {
        const value1 = dropDownValue1
        const value2 = dropDownValue2;
        const result = value1 + " : " + value2;
        setFilterArray([...filterArray, result])
        setIsFilter(true);
        setLoading(true);
        setDropDownValue1('');
        setDropDownValue2('');
    }

    const handleOverlayFilter = (): any => {
        const value1 = dropDownValue1Overlay;
        const value2 = dropDownValue2Overlay;
        const result = value1 + " : " + value2;
        setFilterArray([...filterArray, result])
        setIsFilter(true);
        setIsOverlayFilter(true);
        // setLoading(true);
        setDropDownValue1Overlay('');
        setDropDownValue2Overlay('');
    }

    const handleCloseFilter = (index: any): any => {
        console.log("clicked");
        const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
        setFilterArray(updatedArray);
        !isOverlayFilter && setLoading(true);

        setIsOverlayFilter(false);
    }

    // overflow set contents code starts here
    var overFlowComponent = {
        data:
            <>
                <StackItem> <Divider vertical /> </StackItem>

                <StackItem>
                    <Button
                        size="small"
                        appearance="subtle"
                        disabled={loading}
                        onClick={() => {
                            setCurrentPageNo(1);
                            setIsRefresh(true);
                            setLoading(true);
                        }}
                    >
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
                            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                        </Stack>
                    </Button>

                    {permissions.includes("all") || permissions.includes("deviceClassification_Fullaccess") || permissions.includes("deviceClassification_ReadandExport") ?
                        <>
                            <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_DeviceClassifications.csv`} >
                            </CSVLink>
                            <Button disabled={loading} size="small" appearance="subtle"
                                onClick={() => { setExportBtnClicked(true); }}  >
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem>{loading ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                    <StackItem> <Caption1> Export </Caption1> </StackItem>
                                </Stack>
                            </Button>
                        </>
                        :
                        <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                            <Button appearance="subtle" size="small" disabled>
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem><Text></Text></StackItem>
                                    <StackItem>
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                                            <StackItem><Caption1> Export </Caption1></StackItem>
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </Button>
                        </Tooltip>
                    }
                </StackItem>
            </>
        ,
    };

    if (permissions.includes("all") || permissions.includes("overview_Read") || permissions.includes("overview_ReadandExport") || permissions.includes("overview_Fullaccess")) {
        menuItems.push
            (
                // <FluentProvider theme={lightTheme}>
                <MenuItem key={0} onClick={() => navigate("/manage/search/asset")}
                    icon={
                        <Stack horizontal tokens={{ childrenGap: 40 }}>
                            <StackItem><Text></Text></StackItem>
                            <StackItem> <Info20Regular {...primaryIcon} /> </StackItem>
                        </Stack>}>
                    <Stack tokens={{ childrenGap: 30 }} horizontal>
                        <StackItem><Text></Text></StackItem>
                        <StackItem> <Caption1> Asset </Caption1> </StackItem>
                        <StackItem> <Stack tokens={{ childrenGap: 80 }} horizontal> <StackItem><Text></Text></StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem>
                        {/* SPACING IN INLINE SIDEBAR */}
                    </Stack>
                </MenuItem>
                // </FluentProvider>
            )
    }

    if (permissions.includes("all") || permissions.includes("deviceClassification_Read") || permissions.includes("deviceClassification_ReadandExport") || permissions.includes("deviceClassification_Fullaccess")) {
        menuItems.push
            (
                <FluentProvider theme={lightTheme}>
                    <MenuItem key={1} onClick={() => navigate("/manage/search/event")}
                        icon={
                            <Stack horizontal tokens={{ childrenGap: 40 }}>
                                <StackItem><Text></Text></StackItem>
                                <StackItem> <GroupList20Regular {...primaryIcon} /> </StackItem>
                            </Stack>}>
                        <Stack tokens={{ childrenGap: 30 }} horizontal>
                            <StackItem><Text></Text></StackItem>
                            <StackItem> <Caption1> Event </Caption1> </StackItem>
                        </Stack>
                    </MenuItem>
                </FluentProvider>
            );
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = contextValue.selectedAssetRow;
                const apiUrl = 'https://pinot-nh.unifie.io/sql';

                console.log("query=", query);

                const requestBody = {
                    sql: query,
                    "trace": false,
                    "queryOptions": "useMultistageEngine=true"
                };
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestBody),
                });

                const responseData = await response.json();
                if (responseData) {
                    var assetData = responseData.resultTable
                    setSingleTableData(assetData);
                }
            } catch (error) {
                console.error("An unexpected error occurred=", (error as Error).message);
            }
        }

        fetchData();
    }, [searchVal, currentPageNo, isRefresh])

    return (
        <>

            <FullScreen handle={handle} className="fullScreenBackgroundColor">
            <StackItem grow shrink style={BreadcrumbsBorder}>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                        <Stack tokens={{childrenGap:5}} horizontalAlign="start">
                            <StackItem><Text></Text></StackItem>
                            <StackItem grow shrink>
                            <Breadcrumbs
                                items={[
                                {name:"Manage", link: "/home" },
                                {name:"Search", link:"/manage/search/asset"},
                                {name:"Event", link:"/manage/search/event"},
                                {name:"Results", link:"#"},
                                ]} 
                            /> 
                            </StackItem>
                        </Stack>
                        </StackItem>
                    </Stack>
                </StackItem>
                <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                    <StackItem style={DynamicBoxingCSS}>
                        {/* pages code starts here */}
                        <Stack style={DynamicBoxingCSS}>

                            <Stack tokens={{ childrenGap: 25 }} horizontal>
                                <StackItem> <Text></Text> </StackItem>
                                <StackItem>
                                    <FluentProvider theme={dashboardTheme}>
                                        <Title3> Event | Results </Title3>
                                    </FluentProvider>
                                </StackItem>
                            </Stack>
                            <FluentProvider style={parentHome} theme={dashboardTheme}>
                                <Stack style={parentHome} horizontal>
                                    {/* SPACING BETWEEN INLINE AND PAGE */}
                                    <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={menuItems} />
                                    <StackItem style={DynamicBoxingCSS}>
                                        <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                                            <StackItem>
                                                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                <Divider />
                                            </StackItem>
                                            <StackItem style={wraperStyle}>
                                                <StackItem>
                                                    <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                                        <Stack horizontal tokens={{ childrenGap: 10 }}>
                                                            <StackItem>
                                                            <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={""} searchVal={searchVal} setSearchVal={setSearchVal} disabled={loading || singleAsset.length === 0} />
                                                            </StackItem>
                                                            <StackItem>
                                                                <MenuDropdown open={filterMenuOpen} btn={
                                                                    <MenuButton disabled={loading || singleAsset.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                            <FilterAdd20Filled {...primaryIcon} />
                                                                            <Body1> Filter </Body1>
                                                                        </Stack>
                                                                    </MenuButton>
                                                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                                                    <Divider />
                                                                    <MenuList>
                                                                        <Stack tokens={{ childrenGap: 5 }}>
                                                                            <StackItem> <Text></Text> </StackItem>
                                                                            <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                                            {/* <DropdownComponent optionData={columns1} setDropDownValue = {setDropDownValue1} dropDownvalue = {dropDownValue1} /> */}
                                                                            <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                                                            <StackItem> <Divider /> </StackItem>
                                                                            <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                                            {(dropDownValue1 === 'Installation Date' || dropDownValue1 === 'Last Check-in in 1 Week' || dropDownValue1 === 'Last Check-in in 24 Hours') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                                                            {dropDownValue1 === "Operating System" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                                                            {(dropDownValue1 === "Device Name" || dropDownValue1 === "Manufacturer" || dropDownValue1 === "Nanoheal Version") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                                                            <StackItem> <Divider /> </StackItem>
                                                                            <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                                                <StackItem>
                                                                                    <Button appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                                                        disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                                                                        <Caption1> Apply </Caption1>
                                                                                    </Button>
                                                                                </StackItem>

                                                                                <StackItem>
                                                                                    <Button onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                                                        <Caption1> Cancel </Caption1>
                                                                                    </Button>
                                                                                </StackItem>
                                                                            </Stack>
                                                                        </Stack>
                                                                    </MenuList>
                                                                </>} />
                                                            </StackItem>
                                                            <StackItem onClick={() => { setIsOverlayFilter(false); setFilterArray([]); setIsFilter(false); setDropDownValue2Overlay(''); setResetDisabled(true); }}>
                                                                <Button appearance="subtle" size="small" disabled={isResetDisabled}>
                                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                        <StackItem> <FilterDismiss20Filled /> </StackItem>
                                                                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                                                    </Stack>
                                                                </Button>
                                                            </StackItem>
                                                        </Stack>
                                                        {(singleAsset.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                                                    </Stack>
                                                    {filterArray.length > 0 && <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                                        <Stack wrap horizontal >
                                                            {filterArray.length > 0 && filterArray.map((item, index) => (
                                                                <Button size="small" shape="circular">
                                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                                                        <StackItem>
                                                                            <Stack tokens={{ childrenGap: 1 }}>
                                                                                <StackItem><Text></Text></StackItem>
                                                                                <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                                            </Stack>
                                                                        </StackItem>
                                                                    </Stack>
                                                                </Button>
                                                            ))}
                                                        </Stack>
                                                    </Stack>}
                                                </StackItem>
                                                <InfoBar showSpaces={true} title={"Explore our troubleshooting snippets for a smooth start. Pick a setup scenario, and we'll guide you through each step, handling assignments and other configurations automatically."} />
                                                {singleAsset?.length > 0 && <Stack horizontal enableScopedSelectors horizontalAlign="space-between">
                                                    <StackItem> {totalRecords > 0 && <Caption1> Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records </Caption1>} </StackItem>
                                                </Stack>}
                                            </StackItem>

                                            {refreshToast && <ToastComponent setmessagebar={setRefreshToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

                                            {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={toastMessage} footer="" />}

                                            {errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}
                                            {loading ? (<SkeletonDataTable />) : (selectedAsset && singleAsset.length > 0 ?
                                                (<DataTable tableData={singleAsset} columns={tablecolums} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>)}
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </FluentProvider>
                        </Stack>
                        <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayData} saveBtnFunc={setSaveBtnClicked} isNavBtn={true} />
                    </StackItem>
                    <StackItem><Text></Text></StackItem>

                </Stack >
            </FullScreen >
        </>
    )
}

export default SubEvent;
